export default __webpack_public_path__ + "static/media/delete-icon.15363cf0.svg";